<template>
  <div class="c-main-info">
    <ul>
      <li
        v-for="(item) in main"
        :key="item.index"
      >
        <span :class="{ 'text-muted': fetchingMainData }">{{ item.value }}</span>
        <span :class="{ 'text-muted': fetchingMainData }">{{ item.description }}</span>
        <c-spinner v-if="fetchingMainData" />
      </li>
    </ul>
  </div>
</template>

<script>
import CSpinner from '../../../../../../../resources/js/components/ui/CSpinner.vue'
import apiService from '../../apiService'
import { Notification } from 'uiv'
import { mapGetters } from 'vuex'
import { round } from '../../../../../../../resources/js/helper'

export default {
  name: 'CMainInfo',
  components: {
    CSpinner
  },
  data () {
    return {
      fetchingMainData: false,
      main: {}
    }
  },
  computed: {
    ...mapGetters({
      login: 'Login/getLogin',
      period: 'Period/getPeriod'
    })
  },
  watch: {
    login (newVal, oldVal) {
      if (oldVal !== newVal) {
        this.fetchMainData().then(this.onMainDataResolve)
      }
    },
    period (newVal, oldVal) {
      if (oldVal.from !== newVal.from || oldVal.to !== newVal.to) {
        this.fetchMainData().then(this.onMainDataResolve)
      }
    }
  },
  mounted () {
    this.main = {
      cpl: {
        index: 0,
        value: '0.00 руб.',
        description: 'CPL факт'
      },
      costs: {
        index: 1,
        value: '0.00 руб.',
        description: 'Расход'
      },
      cr: {
        index: 2,
        value: '0.00 %',
        description: 'CR'
      }
    }
    // Костыль, чтобы запрос не отправился с пустым периодом (плавающая проблема и возникает только в момент отрисовки компонента)
    if (this.period.from && this.period.to) {
      this.fetchMainData().then(this.onMainDataResolve)
    }
  },
  methods: {
    /**
     * Метод-обёртка над запросом к API /api/context/main
     * @returns {Promise<AxiosResponse<T>>}
     */
    fetchMainData () {
      this.fetchingMainData = true
      return new Promise(resolve => {
        apiService.getMainData(
          this.period.from,
          this.period.to,
          this.login
        )
          .then(response => {
            this.fetchingMainData = false
            resolve(response.data)
          })
          .catch(data => {
            this.fetchingMainData = false
            Notification.notify.error({
              title: 'Ошибка',
              content: 'Не удалось загрузить основную информацию.'
            })
          })
      })
    },
    /**
     * Метод занимается отрисовкой компонента основных данных
     * @param data Данные из Promise
     */
    onMainDataResolve (data) {
      const cpl = round(data && data.cpl ? data.cpl : 0).toFixed(2)
      const costs = round(data && data.costs ? data.costs : 0).toFixed(2)
      const cr = round(data && data.cr ? data.cr : 0).toFixed(2)
      this.main.cpl.value = `${cpl} руб.`
      this.main.costs.value = `${costs} руб.`
      this.main.cr.value = `${cr} %`
    }
  }
}
</script>

<style scoped lang="scss">
@import '../../../../../../../resources/css/variables';

.c-main-info {
  ul {
    margin: 0;
    padding: 0;
    li {
      position: relative;
      display: inline-block;
      margin: 0;
      padding-left: 48px;
      padding-right: 48px;
      border: none;
      border-right: 1px #8aa4af solid;
      @media all and (max-width: $smBreakpoint - 1) {
        display: block;
        padding: 15px 0;
        border: none;
        border-bottom: 1px #8aa4af solid;
      }
      &:first-child {
        padding-left: 0;
        padding-right: 48px;
        border-left: none;
        @media all and (max-width: $smBreakpoint - 1) {
          padding-top: 0;
          padding-right: 0;
        }
      }
      &:last-child {
        padding-bottom: 0;
        border: none;
      }
      & span {
        display: block;
      }
      & > span {
        font-size: 30px;
      }
      & > span + span {
        font-size: 18px;
        line-height: 110%;
      }
      & > .fa-spin {
        position: absolute;
        display: block;
        margin: auto;
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
        width: 20px;
        height: 20px;
        font-size: 20px;
        line-height: 1;
      }
    }
  }
}
</style>
